<template>
  <div>
    <Filters />
    <SubmissionsList
      :source="'judge'"
      :event-id="event._id"
    />
  </div>
</template>

<script>
import Filters from '@/components/Filters'
import SubmissionsList from '@/components/submissions/SubmissionsList'

export default {
  name: 'JudgeDashboard',
  metaInfo: {
    title: `${process.env.VUE_APP_PAGE_TITLE} - Dashboard`
  },
  components: {
    Filters,
    SubmissionsList
  },
  computed: {
    event () {
      return this.$store.getters.currentEvent
    }
  },
}
</script>
